<template>
  <div>
      <img id="bg">
      <div class="container">
          <div class="justify-content-center">
          <div class="col-md-7 col-lg-5">
              <div class="login">    
                
                <div id="img">
                  <img class="image_stars" src="../../assets/fern_light_green.jpg"  alt="logo">
                  <img class="image_logo" src="../../assets/pura_logo.png"  alt="logo_text">
                </div>
                
                  <q-form @submit.prevent="loginUser" >
                      <div class="login-form-container ">

                      <h2 class="portal-title">Client Sign In</h2>
                      
                      <div class="d-flex justify-content-center">      
                        <q-spinner
                          v-if="loading"
                          color="primary"
                          size="3em"
                        /></div>

                      <div class="login-email">
                          <q-input type="email" class="input-control" id="email" icon="email" icon-right="close-circle" v-model="email" label="Email" :rules="[validateEmail]" >
                              <template v-slot:prepend>
                                <q-icon name="o_email" />
                              </template>
                          </q-input>
                      </div>

                      <div class="login-password">
                          <q-input type="password" class="input-control" id="MyPassword" v-model="password" label="Password" :rules="[val => !!val || 'Password is required']">
                              <template v-slot:prepend>
                                  <q-icon name="o_lock" />
                              </template>
                          </q-input>
                      </div>

                      <div class="form-group">
                          <q-btn flat color="primary" size="md" @click="this.$router.push({name: 'resetPassword'})" label="Forgot Password?" />
                      </div>

                      <div class="form-group">
                          <q-btn :disabled="!isValid" no-caps class="form-button" id="button-login" type="submit" label="Login" />
                      </div>
                      
                      </div> 
                  </q-form> 
              </div>
          </div>
          </div>
      </div>
  </div>
</template>


<script>

import api from "@/services/api/api";
import notify from '@/services/util/notify';
import { initialiseEvents } from "@/services/events/event-initialiser.js"

const ClientLoginComponent = {
  name: "clientLogin",

  data() {
    return {
      email: "",
      password: "",
      isLogged: false,
      loading: false,
    };
  },

  /**
   * Clear the sessionStorage (logs out the user) and set isLogged to false.
   */
  async created() {
    this.isLogged = false;
    this.$q.iconSet.field.error = ''
    sessionStorage.clear();
  },


  computed: {

    /**
     * Checks if the fields contain valid things. This will enable the submit button.
     */
    isValid() {
        return this.password.length > 0 && (this.validateEmail(this.email) != "Invalid email format")
    }
  },

  
  methods: {

      /**
       * Validates a given string as an email using regex.
       */
      validateEmail(email) {
          // eslint-disable-next-line 
          var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
          return re.test(email) || 'Invalid email format';
      },



    /**
     * Handles the login for a user. Calls the login api and sets the session storage to the users information
     */
    loginUser() {

      let payload = {
                email: this.email.toLowerCase(),
                password: this.password
      }

      this.loading = true

      api.users.loginUser(payload)
        .then((res) =>{
          
          sessionStorage.setItem('authToken', res.data.authToken);

          initialiseEvents();

          this.$router.push({name: 'clientDemographic'})
          this.loading = false

          }) 
          .catch(err => {
            this.loading = false
            notify.error(err.response.data ?? "Error logging in", 'top');
          })
      }
    },
}

export default ClientLoginComponent;
</script>

<style scoped>
@import '../../assets/styles/login.css';

</style>


